export enum DiscountType {
  Percentage = 1,
  Amount = 2,
}
export const days = [
  'Воскресенье',
  'Понедельник',
  'Вторник',
  'Среда',
  'Четверг',
  'Пятница',
  'Суббота'
];

export const dayToMs = 86400000;
